<div class="cantainer-fluid">
    <p class="jeemains_text">JEE Mains Hall Ticket Verification </p>
    <div style="padding: 5px 15px;">
        <p class="adm_text">JMS Admission Number</p>
        <div class="input-wrapper">
            <input type="text" class="form-control" [(ngModel)]="searchCriteria" placeholder="Search"
                (keydown)="onKeyDown($event)" (keyup)="onKeyUp($event)">
            <i class="fa fa-search search-icon"></i>

            <ul *ngIf="filteredSearchDetails?.length > 0" class="dropdown-list">
                <li *ngFor="let item of filteredSearchDetails" (click)="selectItem(item)">
                    {{ item.admNo }} ({{ item.name }})
                </li>
            </ul>
        </div>
    </div>
    <div class="jee_mains">

        <div class="ibox">

            <p class="jeemains_text1">As Per Scaits</p>
            <div class="form-row">

                <div class="form-group">
                    <label class="adm_text">Jee Mains Application No</label>

                    <div class="input-with-icon">
                        <input type="text" placeholder="Jee Mains Application No" [(ngModel)]="jeeMainsApplicationNo">
                        <!-- Application No -->
                        <span *ngIf="matchStatus.applicationNo === true" class="icon success">✔</span>
                        <span *ngIf="matchStatus.applicationNo === false" class="icon error">✖</span>
                    </div>

                </div>

                <div class="form-group">
                    <label class="adm_text">Candidate Name</label>
                    <div class="input-with-icon">
                        <input type="text" placeholder="Student Name" [(ngModel)]="studentName" readonly>
                        <!-- Student Name -->
                        <span *ngIf="matchStatus.studentName === true" class="icon success">✔</span>
                        <span *ngIf="matchStatus.studentName === false" class="icon error">✖</span>
                    </div>

                </div>
            </div>
            <div class="form-row">

                <div class="form-group">
                    <label class="adm_text">Date of Birth</label>
                    <div class="input-with-icon">
                        <!-- DOB-->
                        <input type="text" placeholder="DOB" [(ngModel)]="dob" readonly>
                        <span *ngIf="matchStatus.dob === true" class="icon success">✔</span>
                        <span *ngIf="matchStatus.dob === false" class="icon error">✖</span>
                    </div>
                </div>

                <div class="form-group">
                    <label class="adm_text">Father Name</label>
                    <div class="input-with-icon">
                        <input type="text" placeholder="Parent Name" [(ngModel)]="parentName" readonly>
                        <span *ngIf="matchStatus.parentName === true" class="icon success">✔</span>
                        <span *ngIf="matchStatus.parentName === false" class="icon error">✖</span>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label class="adm_text">Gender</label>
                    <!-- <div class="radio-group">
                        <label><input type="radio" name="gender" [(ngModel)]="gender" value="M" [disabled]="true">
                            Male</label>
                        <label><input type="radio" name="gender" [(ngModel)]="gender" value="F" [disabled]="true">
                            Female</label>
                    </div> -->
                    <div class="input-with-icon">
                        <input type="text" placeholder="Gender" [(ngModel)]="displayGender" readonly>
                        <span *ngIf="matchStatus.displayGender === true" class="icon success">✔</span>
                        <span *ngIf="matchStatus.displayGender === false" class="icon error">✖</span>
                    </div>

                </div>

                <!-- <div class="form-group">
                    <label class="adm_text">Mother Name</label>
                    <div class="input-with-icon">
                        <input type="text" placeholder="Mother Name" [(ngModel)]="motherName" readonly>
                        <span *ngIf="matchStatus.motherName === true" class="icon success">✔</span>
                        <span *ngIf="matchStatus.motherName === false" class="icon error">✖</span>
                    </div>
                  
                </div> -->

            </div>

            <!-- not manditory -->
            <!--              
            <div class="form-row">

                <div class="form-group">
                    <label class="adm_text">Campus Name</label>
                    <input type="text" placeholder="Campus Name" [(ngModel)]="campusName" readonly>
                </div>


                <div class="form-group">
                    <label class="adm_text">Student Email</label>
                    <input type="email" placeholder="Student Email" [(ngModel)]="studentEmail" readonly>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label class="adm_text">Category</label>
                    <select name="" id="">
                        <option value="">Select</option>
                    </select>
                </div>

                <div class="form-group">
                    <label class="adm_text">Sponsored by</label>
                    <input type="text" placeholder="Sponsored by" [(ngModel)]='sponseredBy'>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label class="adm_text">Class</label>
                    <input type="text" placeholder="Class Name" [(ngModel)]="className">
                </div>

                <div class="form-group">
                    <label class="adm_text">Stream</label>
                    <input type="text" placeholder="Stream" [(ngModel)]="streanName">
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label class="adm_text">Program Name</label>
                    <input type="text" placeholder="Program" [(ngModel)]="programName">
                </div>

                <div class="form-group checkbox-group">
                    <label class="adm_text">JEE MAINS NOT APPLIED</label>
                    <input type="checkbox" class="big-checkbox">
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label class="adm_text">Not Applied Remarks</label>
                    <select name="" id="">
                        <option value="">Select</option>
                    </select>
                </div>

                <div class="form-group">
                    <label class="adm_text">Exam Type</label>
                    <select name="" id="">
                        <option value="">ONLINE</option>
                    </select>
                </div>
            </div>

            <div class="form-row">

                <div class="form-group">
                    <label class="adm_text">City Name</label>
                    <input type="text" placeholder="City Name" [(ngModel)]="cityName" readonly>
                </div>

                <div class="form-group">
                    <label class="adm_text">Mobile No.(Which is registered in mains exam)</label>
                    <input type="text" placeholder="Mobile No" [(ngModel)]="mobileNo">
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label class="adm_text">Jee Mains Password</label>
                    <input type="text" placeholder="Jee Mains Password" [(ngModel)]="jeeMainsPassword">
                </div>

                <div class="form-group">
                    <label class="adm_text">Jee Mains HT-No</label>
                    <input type="text" placeholder="Jee Mains HT-No">
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label class="adm_text">VIT HT-No</label>
                    <input type="text" placeholder="VIT HT-No" [(ngModel)]="VitHtno">
                </div>

                <div class="form-group">
                    <label class="adm_text">VIT Password</label>
                    <input type="text" placeholder="VIT Password" [(ngModel)]="VitPassword">
                </div>
            </div>

            <div class="form-row">
                <div class="form-group checkbox-group">
                    <label class="adm_text">Mains Applied Status</label>
                    <input type="checkbox" class="big-checkbox">
                </div>

                 <div class="form-group">
                    <label class="adm_text">VIT Password</label>
                    <input type="text" placeholder="VIT Password">
                </div> 
            </div> -->

            <!-- not manditory -->

        </div>
        <div class="ibox1">

            <p class="jeemains_text1">As Per Jee Mains</p>
            <!-- upload pdf file -->

            <div *ngIf="ocrText">

                <div class="form-row">
                    <div class="form-group">
                        <label class="adm_text">Application No</label>
                        <input type="text" placeholder="Not Found" [(ngModel)]="govtApplicationNo">
                    </div>

                    <div class="form-group">
                        <label class="adm_text">Candidate Name</label>
                        <input type="text" placeholder="Not Found" [(ngModel)]="govtcandidateName">
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label class="adm_text">
                            Date of Birth
                        </label>
                        <input type="text" placeholder="Not Found" [(ngModel)]="govtDB">
                    </div>

                    <div class="form-group">
                        <label class="adm_text">Father Name
                        </label>
                        <input type="text" placeholder="Not Found" [(ngModel)]="govtfatherName">
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label class="adm_text">Gender</label>
                        <input type="text" placeholder="Not Found" [(ngModel)]="govtGender">
                    </div>
                    <!-- 
                    <div class="form-group">
                        <label class="adm_text">Mother Name</label>
                        <input type="text" placeholder="Not Found" [(ngModel)]="govtmotherName" readonly>
                    </div> -->
                </div>

                <!-- <div class="form-row">
                    <div class="form-group">
                        <label class="adm_text">Nationality</label>
                        <input type="text" placeholder="Not Found" [(ngModel)]="govtNationality" readonly>
                    </div>
                </div> -->
            </div>

            <div class="form-grouppdf pdf-upload">
                <label class="adm_text">Upload Student PDF</label>
                <input type="file" accept="application/pdf" id="pdfInput" (change)="onPdfSelect($event)" hidden>
                <!-- <input type="file" accept="application/pdf" id="pdfInput" (change)="onFileSelected($event)" hidden> -->

                <label for="pdfInput" class="upload-box">
                    <i class="fa fa-file-pdf-o pdf-icon"></i>
                    <span *ngIf="!selectedPdf">Click to upload PDF</span>
                    <span *ngIf="selectedPdf">{{ selectedPdf.name }}</span>
                </label>

                <!-- <button class="btn-upload" [disabled]="!selectedPdf">
                    Upload PDF
                </button> -->

                <!-- Loading State -->
                <div *ngIf="loading" class="loading-overlay">
                    <div class="spinner"></div>
                    <p>Processing Document...</p>
                </div>
            </div>

            <div class="raw-text-section">
                <details>
                    <summary>View Raw OCR Text</summary>
                    <pre>{{ ocrText }}</pre>
                </details>
            </div>




        </div>

        <!-- <div class="text-center">
            <button class="submit_btn" (click)="submit()">Submit</button>
        </div> -->
        
    </div>
</div>


<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>